;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('ApplicationHistoryController', [
      '$uibModalInstance',
      'applicationId',
      'SharedApi',
      'agentsList',
      'isOffPlatform',
      'isNote',
      'stagesList',
      '$rootScope',
      'logger',
      '$uibModal',
      '$scope',
      'enableMasterGrid',
      'NotesApi',
      function controller(
        $uibModalInstance,
        applicationId,
        SharedApi,
        agentsList,
        isOffPlatform,
        isNote,
        stagesList,
        $rootScope,
        logger,
        $uibModal,
        $scope,
        enableMasterGrid,
        NotesApi
      ) {
        var vm = this
        $rootScope.$on('application-deleted', (event, {applicationDeleted}) => {
          if (applicationId === applicationDeleted) {
            logger.notify('error', 'Application Deleted by Other Admin')
            vm.close()
          }
        })

        vm.applicationId = applicationId
        vm.agentsList = agentsList
        vm.isNote = isNote
        vm.enableMasterGrid = enableMasterGrid
        vm.stagesList = stagesList
        vm.source = isOffPlatform ? 'Off-Platform' : 'On-Platform'

        vm.close = () => {
          const latestNote = vm.allApplication.find(note => note.isNote)
          $uibModalInstance.close(latestNote ? latestNote.body : '')
        }

        vm.loadApplicationNoteAndHistory = async () => {
          const [
            {data: applicationNotes},
            {data: applicationActionHistory},
          ] = await Promise.all([
            NotesApi.getAllNotes({
              application: [vm.applicationId],
            }),
            SharedApi.getAllActions({
              category: 'application',
              target: vm.applicationId,
            }),
          ])

          vm.applicationActionHistory = applicationActionHistory.map(
            history => {
              const author = vm.agentsList.find(
                ({id}) => id === history.authorId
              )

              if (!history.payload) {
                history.payload = {}
              }

              const applicationAgent =
                history.typeId === 'APPLICATION_FOLLOW_UPDATE' &&
                history.payload
                  ? history.payload.userIds
                      .map(user => {
                        return vm.agentsList.find(({id}) => id === user).email
                      })
                      .join(' ,')
                  : ''

              history.payload.current =
                history.payload && history.payload.current
                  ? Object.assign(
                      {},
                      ...Object.keys(history.payload.current).map(key => {
                        if (key === 'stageId')
                          history.payload.current[key] = vm.stagesList.find(
                            ({id}) => id === history.payload.current.stageId
                          ).name
                        return {
                          [key]: history.payload.current[key],
                        }
                      })
                    )
                  : ''

              history.payload.old =
                history.payload && history.payload.old
                  ? Object.assign(
                      {},
                      ...Object.keys(history.payload.old).map(key => {
                        if (key === 'stageId')
                          history.payload.old[key] = vm.stagesList.find(
                            ({id}) => id === history.payload.old.stageId
                          ).name
                        return {
                          [key]: history.payload.old[key],
                        }
                      })
                    )
                  : ''
              const keyName =
                history.payload && history.payload.current
                  ? Object.keys(history.payload.current)
                      .map(key => {
                        const headerName = keyValue(key)
                        return headerName
                      })
                      .filter(x => x)
                      .join(' , ')
                  : ''
              return {
                payload: history.payload,
                keyName,
                current:
                  history.payload && history.payload.current
                    ? Object.values(history.payload.current).join(' ,')
                    : '',
                old:
                  history.payload && history.payload.old
                    ? Object.values(history.payload.old).join(' ,')
                    : '',
                created: history.created,
                typeId: history.typeId,
                applicationAgent,
                author: author ? author.email : '',
              }
            }
          )
          vm.applicationNotes = applicationNotes.map(note => {
            const author = vm.agentsList.find(({id}) => id === note.authorId)
            return {
              id: note.id,
              isNote: true,
              body: note.body,
              created: note.created,
              author: author ? author.email : '',
            }
          })
          vm.toggleHistory()
        }

        vm.toggleHistory = () => {
          if (vm.isNote) {
            vm.allApplication = [
              ...vm.applicationActionHistory,
              ...vm.applicationNotes,
            ]
              .filter(history => history.isNote === true)
              .sort((a, b) => (a.created < b.created ? 1 : -1))
          } else
            vm.allApplication = [
              ...vm.applicationActionHistory,
              ...vm.applicationNotes,
            ].sort((a, b) => (a.created < b.created ? 1 : -1))
        }

        vm.editNote = history => {
          history.temporaryNote = history.body
          history.isEditable = true
        }

        vm.updateNote = async history => {
          if (history.temporaryNote && history.temporaryNote !== '') {
            try {
              const payload = {
                body: history.temporaryNote,
                authorId: $rootScope.user.id,
              }
              const {status} = await NotesApi.updateNote(history.id, payload)
              if (status === 200) {
                history.body = history.temporaryNote
                history.isEditable = false
                $scope.$apply()
                logger.notify('success', `Internal Note updated successfully!`)
              }
            } catch (error) {
              logger.notify('error', error.data.message)
            }
          }
        }

        vm.createNote = async () => {
          if (vm.newNote && vm.newNote !== '') {
            const payload = {
              body: vm.newNote,
              subject: 'Internal Note',
              category: 'Comment',
              applicationId: vm.applicationId,
              authorId: $rootScope.user.id,
            }
            try {
              const {data, status} = await NotesApi.createNote(payload)
              if (status === 201) {
                vm.newNote = ''
                const newNote = {
                  isNote: true,
                  id: data.id,
                  body: data.body,
                  created: data.created,
                  author: $rootScope.user ? $rootScope.user.email : '',
                }
                vm.applicationNotes.push(newNote)
                vm.allApplication = [newNote, ...vm.allApplication]
                $scope.$apply()
                logger.notify('success', `Internal Note added to Application`)
              } else {
                logger.notify('error', `Error occurred`, status)
              }
            } catch (error) {
              logger.notify('error', error.data.message)
            }
          }
        }

        vm.discardNote = history => {
          history.isEditable = false
        }

        vm.deleteNoteModal = id => {
          const deleteModalInstance = $uibModal.open({
            templateUrl: 'delete-internal-note-modal.html',
            controllerAs: 'deleteNoteCtrl',
            controller: function() {
              let vm = this
              vm.cancel = () => {
                deleteModalInstance.dismiss('cancel')
              }

              vm.confirmDelete = () => {
                deleteModalInstance.close()
              }
            },
          })
          deleteModalInstance.result.then(
            async () => {
              try {
                const {status} = await NotesApi.deleteNote(id)
                if (status === 200) {
                  vm.applicationNotes = vm.applicationNotes.filter(
                    note => note.id !== id
                  )
                  vm.allApplication = vm.allApplication.filter(
                    note => note.id !== id
                  )
                  $scope.$apply()
                  logger.notify(
                    'success',
                    `Internal Note deleted successfully!`
                  )
                } else {
                  logger.notify('error', `Error occurred`, status)
                }
              } catch (error) {
                logger.notify('error', error.data.message)
              }
            },
            () => {}
          )
        }

        vm.loadApplicationNoteAndHistory()
      },
    ])
})()

const keyValue = key => {
  switch (key) {
    case 'submittedAt':
      return 'Submission Date'
    case 'interview1Date':
      return '1st Interview Date'
    case 'interview2Date':
      return '2nd Interview Date'
    case 'interview3Date':
      return '3rd Interview Date'
    case 'offer':
      return 'Offer {£ Value}'
    case 'acceptedAt':
      return 'Acceptance Date'
    case 'startDate':
      return 'Start Date'
    case 'feedback':
      return 'Feedback To Candidate'
    case 'status':
      return 'Status'
    case 'stageId':
      return 'Stage'
    default:
      break
  }
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-history/application-history.ctrl.js